// React
import React from "react";
// Griddle
import Griddle from "griddle-react";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SimpleTable.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class SimpleTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { reportItems, metaData, initialSort } = this.props;
        return (React.createElement("div", { className: styles.container },
            React.createElement(Griddle, { results: reportItems, tableClassName: "griddle-simple", columnMetadata: metaData, showFilter: false, showSettings: false, sortAscendingComponent: React.createElement("span", { className: "fa fa-sort-asc" }), sortDescendingComponent: React.createElement("span", { className: "fa fa-sort-desc" }), initialSort: initialSort, useGriddleStyles: true, metadataColumns: this.props.excludeColumns, useFixedHeader: false, resultsPerPage: 25, showPager: reportItems.length > 25, useCustomPagerComponent: false })));
    }
}
